import { Button } from '@rematter/ui-web';
import { useAtomValue, useSetAtom } from 'jotai';

import { FreightChargeLineItem } from './FreightChargeLineItem';

import {
  $materialsReconciliationForm,
  $addFreightCharge,
} from '~/modules/trade/_state/loadReconciliation.state';
import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { zeroMoney } from '~/modules/trade/utils/money';

export type FreightChargeCardProps = {
  dialogMode?: boolean;
  disabled?: boolean;
};

export const FreightChargeCard = ({
  dialogMode = true,
  disabled = false,
}: FreightChargeCardProps) => {
  const t = useTranslations();
  const form = useAtomValue($materialsReconciliationForm);
  const addFreightCharge = useSetAtom($addFreightCharge);

  const handleAddFreightCharge = () => {
    addFreightCharge({
      hauler: '',
      freightLane: '',
      deliveryNumber: '',
      accruedAmount: zeroMoney(),
      chargebackAmount: zeroMoney(),
    });
  };

  // If it's disabled and there are no freight charges, return null
  if (disabled && form.freightCharges.length === 0) {
    return null;
  }

  return (
    <div className="@FreightChargeCard border-b border-neutral/20 bg-white py-4">
      <div className="mb-4 flex items-center justify-between">
        {form.freightCharges.length > 0 ? (
          <div className="text-base font-semibold text-neutral/70">
            {t.materialsReconciliation.freightCharge.title}
          </div>
        ) : (
          <div className="py-4 text-neutral/60">
            {t.materialsReconciliation.freightCharge.emptyState}
          </div>
        )}
        {!disabled && (
          <Button
            variant="outline"
            onPress={handleAddFreightCharge}
            className="flex items-center gap-2"
          >
            {t.materialsReconciliation.freightCharge.addButton}
          </Button>
        )}
      </div>

      <div className="space-y-2">
        {form.freightCharges.map((freightCharge) => (
          <FreightChargeLineItem
            key={freightCharge.id}
            freightCharge={freightCharge}
            dialogMode={dialogMode}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
};
